module.exports = __webpack_public_path__ + "static/media/fold-dolly-tool.e51d76db.png";